<template>
    <v-footer
        padless
    >
        <v-container>
            <v-row class="d-flex justify-center my-4" >
                <!-- <v-col cols="4" md="2" align-self="center" justify-self="center">
                    <v-avatar size="100%">
                        <v-img v-bind:src="require('@/assets/image/takamatsu.png')">
                        </v-img>
                    </v-avatar>
                    <div class="mt-1 text-center">すすむテック！<br/>高松奨</div>
                </v-col> -->
                <v-col cols="12" md="10">
                    <v-card
                        flat
                        color="rgba(0,0,0, 0.0)"
                        class="pa-4">
                        <v-card-text>
                            2030年、日本では約100万人のIT人材が不足すると予測されています。<br>
                            すすむテック！では、たくさんの方々が、子供達に簡単にプログラミングを教えることができるようなプログラミング学習コンテンツを制作する活動を、個人で行っています。
                        </v-card-text>
                        <div class="subtitle-1 ml-4 font-weight-bold">
                            お問い合わせ
                        </div>
                        <v-btn
                            v-for="contact in contacts"
                            :key="contact"
                            class="white--text mx-3"
                            fab
                            small
                            :href="contact.url"
                            target="_blank"
                            color="orange"
                        >
                            <v-icon dark>{{ contact.icon }}</v-icon>
                        </v-btn>
                        <!-- <div class="subtitle-1 mt-6 font-weight-bold">
                            <v-btn
                                class="mx-3"
                                small
                                :to="{name:'koshigaya'}"
                                target="_blank"
                            >
                                すすむテック！こどもプログラミング教室（オンライン）
                            </v-btn>
                        </div> -->
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-footer>
</template>

<script>
  export default {
    data: () => ({
      contacts: [
        {icon:'mdi-facebook',url:'https://www.facebook.com/st5757sa'},
        {icon:'mdi-twitter',url:'https://twitter.com/codomo_pro'},
      ],
    }),
  }
</script>
